import { useNavigate } from 'react-router-dom';

import { PopoverInfiniteScroll, WithPopover } from '@american-autonomy/ag-ui';

import DetailsViewEntityMenuItem from 'components/DetailsViewEntityMenuItem';
import SkeletonText from 'components/loaders/SkeletonText';
import LabelText from 'components/text/LabelText';

import { MENU_DIRECTION, TEST_ID } from './constants';
import type { FunctionComponent, Props } from './types';

import styles from './styles.module.scss';

const EntityMenu: FunctionComponent<Props> = ({
    className = '',
    count,
    entityTypeLabel,
    fetchNext,
    hasNextPage,
    items,
    testId = TEST_ID
}) => {
    const navigate = useNavigate();

    return (
        <WithPopover
            trigger={
                <LabelText
                    className={styles.labelText}
                    testId={testId}
                    text={`${count} ${entityTypeLabel}`}
                />
            }
            className={`${className} ${styles.withPopover}`}
            direction={MENU_DIRECTION}>
            <PopoverInfiniteScroll
                className={styles.infiniteScroll}
                fetchNextPage={fetchNext}
                hasNextPage={hasNextPage}
                loader={<SkeletonText lines={1} />}>
                {items?.map(({ entityId, entityName, entityRoute }) => (
                    <DetailsViewEntityMenuItem
                        entityName={entityName}
                        key={entityId}
                        onClick={() => navigate(entityRoute)}
                    />
                ))}
            </PopoverInfiniteScroll>
        </WithPopover>
    );
};

export default EntityMenu;
